import { render, staticRenderFns } from "./StoryCreator.vue?vue&type=template&id=2b5c9200&scoped=true"
import script from "./StoryCreator.vue?vue&type=script&lang=js"
export * from "./StoryCreator.vue?vue&type=script&lang=js"
import style0 from "./StoryCreator.vue?vue&type=style&index=0&id=2b5c9200&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5c9200",
  null
  
)

export default component.exports